var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotationNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 37,
    viewBox: "0 0 30 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0512 29.4257H16.6752V27.6137H20.2992V18.5536H13.0512V16.7416H20.2992V13.1176H16.6752V11.3056H13.0512V13.1176H9.42721V22.1776H16.6752V23.9897H9.42721V27.6137H13.0512V29.4257ZM0.367188 36.6737V0.433594H18.4872L29.3593 11.3056V36.6737H0.367188Z",
    fill: "#EDFEFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotationNew);
export default __webpack_public_path__ + "static/media/quotationNew.c3bc284aba7f5b3a2345c717555be095.svg";
export { ForwardRef as ReactComponent };